<template>
  <TemplateContentSubNav ref="pageContent">
    <template #navigation>
      <DisplaySection gap="xl" tag="nav">
        <NavigationButtonLibraryNomad v-if="isAboveL" />
        <NavigationLibraryBooksSlider v-if="!isAboveL" variant="outlined" />
        <NavigationLibraryBooksList v-if="isAboveL" />
      </DisplaySection>
    </template>
    <TemplateContentAside>
      <TemplateSectionWithHeader>
        <template #header>
          <DisplaySection>
            <heading tag="h1" :icon="iconTitle">
              {{ title }}
            </heading>
            <SearchInput
              v-model:input-query="inputQuery"
              :enable-history="true"
              @submit="handleSubmit"
            />
          </DisplaySection>
        </template>
        <DisplaySection>
          <ViewRouter />
        </DisplaySection>
      </TemplateSectionWithHeader>
      <template #aside>
        <DisplaySection>
          <GamingAsideScore />
        </DisplaySection>
      </template>
    </TemplateContentAside>
  </TemplateContentSubNav>
  <ModalViewerWrapper />
</template>
<script setup lang="ts">
const { ancestors, section, currentContent } = inject(INJECT_CATEGORY_PAGE);

const { inputQuery, forceSubmit } = useSearchInputRedirect();

const { isDesktop, greaterOrEqual } = useEvaBreakpoints();

const isAboveL = greaterOrEqual('l');

const handleSubmit = () => {
  forceSubmit();
};

const profile = useProfileStore();

const breadcrumbLinks = useCategoryAncestorsLinks(
  ancestors,
  section.value,
  currentContent
);

useWebsiteHead({ title: breadcrumbLinks.map((l) => l.label).join(' - ') });

const title = computed(() => {
  return `${currentContent.value.longName}`;
});

const pageContent = ref<HTMLElement>(null);

const { top: offset } = useElementBounding(pageContent);

const anchorsList = useAnchors(offset);

provide(INJECT_ANCHORS, anchorsList);

const iconTitle = computed(() => {
  return '';
});
</script>
